'use client';
import { useRef, useState } from 'react';
import FormEmail from './FormEmail';
import FormInput from './FormInput';
import FormDate from './FormDate';
import FormTextarea from './FormTextarea';
import FormSelect from './FormSelect';
import FormRadio from './FormRadio';
import FormCheckbox from './FormCheckbox';
import FormInputAndCheckbox from './FormInputAndCheckbox';
import FormPrivacy from './comps/FormPrivacy';
import FormSubscribe from './comps/FormSubscribe';
import FormRecaptcha from './comps/FormRecaptcha';
import styles from './index.module.scss';
import { sendFormCommon } from './sendApis';
import getLocal from '@/app/utils/getLocal';
import { subscribe, sendSubscribeGet } from '@/service/vip';
import { message } from 'antd';
import gtm from '@/utils/gtm';

// 需要传输到 leads 的页面
const LEADS_PAGE = {
    us: [
        '/delta-pro-ultra',
        '/smart-home-panel-2?withHeader=1',
        '/ef-quote-form',
        '/delta-pro-3-portable-power-station',
        '/calculators/delta-pro-ultra',
        '/whole-home-backup-power-solution',
        '/delta-pro-portable-power-station',
        '/delta-pro-ultra-daily-use',
        '/delta-pro-ultra-x',
        '/smart-home-panel-2',
        '/power-preparedness',
        '/battery-backup-for-home',
    ],
};

const pageSourceObj: any = {
    '/delta-pro-ultra-daily-use': 'daily use',
    '/calculators/delta-pro-ultra': 'daily use',
    '/delta-pro-ultra': 'backup',
    // '/smart-home-panel-2?withHeader=1': 'backup',
    '/smart-home-panel-2': 'shp2',
    '/whole-home-backup-power-solution': 'HBP',
    '/delta-pro-3-portable-power-station': 'DP3',
    '/delta-pro-portable-power-station': 'DP',
    '/dpu-home-solution': 'dus',
    '/delta-pro-ultra-x': 'DPU X',
    '/battery-backup-for-home': 'battery',
    '/power-preparedness': 'power-prepareaness',
};
export default function FormCommon({ id, data, channel, callback }: any) {
    const { theme, isPrivacy = true, isSubscribe = true, isRecaptcha = false, list = [] } = data;
    const { locale, pathname, query } = getLocal();
    const [listA, setListA] = useState(list);
    const [disabledSub, setDisabledSub] = useState(true); //置灰提交按钮
    const [privacyFlag, setPrivacyFlag] = useState(true); //是否已点击隐私协议
    const [subscribeFlag, setSubscribeFlag] = useState(true); //是否已点击订阅
    const [recaptchaVal, setRecaptchaVal] = useState(''); //人机验证的值
    const [isOpenCheck, setIsOpenCheck] = useState(false);
    const IS_COSTCO = query?.source === 'costco' && locale === 'us' && ['/ef-quote-form'].includes(pathname);
    const IS_SHOPIFY = query?.source === 'Shopify' && locale === 'ca';

    // 处理 stateCode
    const stateCode = useRef<undefined | string>(undefined);
    // 单项值变化回调
    const itemCallback = (item: any, index: number, value: any, select?: any) => {
        const listA2 = JSON.parse(JSON.stringify(listA));
        const item2 = listA2[index] || {};
        if (item2.formType === 'inputAndCheckbox') {
            item2.data = item.data;
        } else {
            item2.itemVal = value;
        }

        if (item.formType === 'select' && select?.stateCode) {
            stateCode.current = select.stateCode;
        }
        setListA(listA2);
        // 是否置灰
        getVerifFromList(listA2);
    };
    // 是否置灰
    const getVerifFromList = (list: any, options?: any) => {
        let flag = true; //默认通过
        list.forEach((item: any) => {
            if (item.isRequire && !item.itemVal) {
                flag = false;
            }
        });

        // 配置了隐私协议,需要同意
        if (isPrivacy && !privacyFlag) {
            flag = false;
        }
        // 人机验证
        const options2 = options || {};
        const recaptchaVal2 = options2.recaptchaVal || recaptchaVal;
        if (isRecaptcha && !recaptchaVal2) {
            flag = false;
        }

        setDisabledSub(!flag); //设置是否置灰
        return flag;
    };
    // 从 list 中获取发送数据库的值
    const getParamsFromList = (list: any) => {
        const params: any = {};
        list.forEach((item: any) => {
            const itemKey = item.itemKey;
            if (item.formType === 'radio') {
                params[itemKey] = item.itemVal === 'Y' ? true : false;
            } else if (item.formType === 'inputAndCheckbox') {
                // answer6 拆成了 answer6Pre、answer6Sub
                item?.data?.forEach((i) => {
                    if (i.formType === 'input') {
                        if (i.itemVal) {
                            params[i.paramsKey] = i.itemVal + i.suffix;
                        }
                    } else if (i.formType === 'checkbox') {
                        let value = '';
                        i.itemVal.forEach((j, idx) => {
                            if (idx !== 0) value += ';';
                            value += j;
                        });
                        if (value) {
                            params[i.paramsKey] = value;
                        }
                    }
                });
            } else if (itemKey) {
                params[itemKey] = item.itemVal;
            }
        });

        // 人机验证
        if (isRecaptcha) {
            params.recaptchaResponse = recaptchaVal;
        }

        // 页面来源
        if (pathname === '/smart-home-panel-2' && query?.withHeader === '1') {
            params.source = 'backup';
        } else if (locale === 'ca' && (pathname === '/delta-pro-ultra' || pathname === '/calculators/delta-pro-ultra')) {
            if (pathname === '/delta-pro-ultra') {
                params.source = 'DPU';
            } else {
                params.source = 'calculators';
            }
            params.products = 'DELTA Pro Ultra';
        } else {
            params.source = pageSourceObj[pathname] || 'daily use';
        }
        if (IS_COSTCO) {
            params.source = 'costco';
        }
        if (IS_SHOPIFY) {
            params.source = 'Shopify';
        }

        // CRM Leads
        if (!!LEADS_PAGE[locale as 'us']?.includes(pathname) && !IS_COSTCO) {
            params.targetSystem = 'LEADS';
            if (stateCode.current) {
                params.stateCode = stateCode.current;
            }
        }

        // 新增渠道值 2025-11-25
        if (channel) {
            params.utmSource = channel;
        }

        return params;
    };
    // 从 list 中取出邮箱并订阅
    const getEmailFromList = (list: any) => {
        let email = '';
        list.forEach((item: any) => {
            if (item.formType === 'email') {
                email = item.itemVal;
            }
        });
        return email;
    };
    // 提交
    const submitHandle = async () => {
        const flag = getVerifFromList(listA);
        if (flag) {
            const params = getParamsFromList(listA);
            const res = await sendFormCommon(params, locale);
            if (res.code === '0') {
                const email: string = getEmailFromList(listA);
                subscribe(email, locale, 'Web new product sub');
                sendSubscribeGet(email);
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: 'Submit',
                    status: 'success',
                });
                callback && callback();
                if (pathname === '/delta-pro-ultra-x') {
                    message.success('Submit Successfully!');
                    setDisabledSub(true);
                }
            } else {
                gtm.push({
                    event: 'uaEvent',
                    event_name: 'pre_order_submit',
                    button_name: 'Submit',
                    status: 'fail',
                });
                message.error(res.message);
                console.log('fail');
            }
        } else {
            setIsOpenCheck(true);
        }
    };
    // 隐私协议回调
    const privacyCallback = (flag: boolean) => {
        setPrivacyFlag(flag);
        getVerifFromList(listA);
    };
    // 邮箱订阅回调
    const subscribeCallback = (flag: boolean) => {
        setSubscribeFlag(flag);
    };
    // 人机验证回调
    const recaptchaCallback = (val: string) => {
        setRecaptchaVal(val);
        getVerifFromList(listA, {
            recaptchaVal: val,
        });
    };
    return (
        <div className={`${styles.FormCommon} from-common-theme-${theme}`}>
            {listA.map((item: any, index: number) => {
                return (
                    <div
                        key={index}
                        className={`form-common-item${isOpenCheck && item.isRequire && !item.itemVal ? ' form-common-show-error' : ''} form-common-${
                            item.formWidth
                        }`}
                    >
                        {item.formType === 'email' && <FormEmail id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'input' && <FormInput id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'textarea' && <FormTextarea id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'select' && <FormSelect id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'radio' && <FormRadio id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'checkbox' && <FormCheckbox id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'date' && <FormDate id={id} data={item} index={index} callback={itemCallback} />}
                        {item.formType === 'inputAndCheckbox' && <FormInputAndCheckbox id={id} data={item} index={index} callback={itemCallback} />}
                    </div>
                );
            })}
            {isPrivacy && <FormPrivacy callback={privacyCallback} />}
            {isSubscribe && <FormSubscribe callback={subscribeCallback} />}
            {isRecaptcha && <FormRecaptcha theme={theme} callback={recaptchaCallback} />}
            <div className="form-common-submit-box">
                <div className={`form-common-submit-btn ${disabledSub ? ' form-common-submit-disabled' : ''}`} onClick={submitHandle}>
                    Submit
                </div>
            </div>
        </div>
    );
}
